import React from 'react';
import { EditorWizardContext } from '../../../hoc/EditorWizard';
import { LocalizationContext } from '../../../hoc/Localization';
import StepContainer from '../StepContainer';
import TitleDescription from './TitleDesciption';

const TitleDescriptionComponent = () => {
  const { edited, updateContent, step } = React.useContext(EditorWizardContext);
  const { t } = React.useContext(LocalizationContext);

  const setValue = (data, key) => {
    updateContent(key, data);
  };

  const { title, description } = edited;

  return (
    <StepContainer nextButtonDisabled={!title || !description} step={step}>
      <TitleDescription t={t} title={title} setValue={setValue} description={description} />
    </StepContainer>
  );
};

export default TitleDescriptionComponent;
